import { useState } from 'react';

const ReasoningPanel = ({ reasoning, warnings = [] }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  if (!reasoning && (!warnings || warnings.length === 0)) {
    return null;
  }

  return (
    <div className="border border-gray-200 p-3">
      <button
        onClick={() => setIsExpanded(!isExpanded)}
        className="w-full flex items-center justify-between text-left"
      >
        <span className="text-xs font-light uppercase tracking-wide text-gray-600">Why this order?</span>
        <span className="text-xs font-light text-gray-400">{isExpanded ? '−' : '+'}</span>
      </button>

      {isExpanded && (
        <div className="mt-3 space-y-2">
          {reasoning && (
            <div>
              <p className="text-xs font-light text-gray-600 whitespace-pre-line">{reasoning}</p>
            </div>
          )}
          
          {warnings && warnings.length > 0 && (
            <div>
              <h4 className="text-xs font-light text-gray-600 mb-1">⚠️ Warnings:</h4>
              <ul className="list-disc list-inside space-y-0.5">
                {warnings.map((warning, index) => (
                  <li key={index} className="text-xs font-light text-gray-500">{warning}</li>
                ))}
              </ul>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default ReasoningPanel;

